var config = {
    requestBaseUrl: "https://cwbz.chy12.com/",
    uploadFileBaseUrl: "https://cwbz.chy12.com/"
};

export default config;
